export const megaPantone = {
    white:'#000000',
    orange:'#EF6C00',
    green:'#009688'
}

export const megaColorTheme = {
    primary:megaPantone.white,
    secondary:megaPantone.green
}
